import { fg } from '@atlaskit/platform-feature-flags';
import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';
import { type ConversationAction } from '@atlassian/rovo-conversation-actions/types';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { MigratedBaseConversationAction } from '../types';

import { buildConversationStarter } from './buildConversationStarter';

/**
 * Finds the first registered nudge recommended by a service response. When multiple
 * nudges are present, the service response (BE) determines order.
 *
 * @param recommendations Nudges recommended by a service response (BE)
 * @param availableNudges Nudges registered by the consumer (FE)
 * @returns ConversationAction, or undefined if no match found
 */
export const findActiveNudge = (
	recommendations: NudgeRecommendationDetails[],
	availableNudges: ConversationAction[],
): MigratedBaseConversationAction | undefined => {
	for (let recommendation of recommendations) {
		if (recommendation.cta.cta_action === 'CHAT' && fg('aix_convo_starter_nudge_enabled')) {
			return {
				...buildConversationStarter(recommendation),
				recommendationNudgeId: recommendation.nudge_id,
			};
		}

		const matchedNudge = availableNudges.find(
			(nudge) => nudge.id === recommendation.feature_details.feature_id,
		);

		const matchedNudgeByContextId = availableNudges.find(
			(action) => action.nudgeContext?.id === recommendation.feature_details.feature_id,
		);

		if (matchedNudge) {
			return {
				...matchedNudge,
				recommendationNudgeId: recommendation.nudge_id,
			};
		}

		if (matchedNudgeByContextId) {
			return {
				...matchedNudgeByContextId,
				recommendationNudgeId: recommendation.nudge_id,
			};
		}
	}

	return undefined;
};
